import { MenuItem } from '@material-ui/core';
import NgpTextField from './NgpTextField';
import { useStyles } from './FormStyles';

export default function NgpSelect(props) {
    const classes = useStyles();
    const { children, addEmptyOption } = props;

    return (
        <NgpTextField {...props} select>
            {addEmptyOption && <MenuItem className={classes.emptySelectOption} value="" />}
            {children}
        </NgpTextField>
    );
}
